<template>
	<section class="pages">
		<div class="fx-align login-wapper">
			<!-- 登录模块 和 找回密码模块控制-->
			<div :class="{'fn-hide':isResetPwd}">
				<!--改变class：sign-in:从注册页切换回登陆，register：从登陆页切换到注册-->
				<section  class="wapper" :class="status">
					<div class="logo-wapper fx fx-y-center fx-x-between">
						<div class="logo-cont">
							<img src="../assets/img/logo_100.png"/>
						</div>
						<div class="logo-words">
							<img src="../assets/img/logo_words.png"/>
						</div>
					</div>
					<div class="user-info-cont">
						<div class="login-cont">
							<div class="user-info text-center">
								<div class="input-cont name-cont m-b-20">
									<i class="icon-personal"></i>
									<input type="tel" placeholder="手机号" maxlength="11" v-model.trim="params.phone" />
								</div>
								<div class="input-cont password-cont m-b-30">
									<i class="icon-lock"></i>
									<input type="password" placeholder="密码" v-model.trim="params.password" @keyup.enter="handleLogin" />
								</div>
								<div class="input-cont code-cont">
									<div id="captcha">
							            <p v-if="isWait">正在加载验证码......</p>
							        </div>
								</div>
							</div>
							<div class="btns m-t-30">
								<div class="login-btn" ><a @click="handleLogin">登<span class="p-l-20"></span>录</a></div>
								<div class="operation m-t-20 fx fx-x-between">
									<a @click="handleRetrievePwd">找回密码</a>
									<a @click="handleStatus('register')">注<span class="p-l-10"></span>册</a>
								</div>
							</div>
						</div>
						<!--默认隐藏-->
						<div class="sign-up-cont">
							<div class="">
								<div class="input-cont name-su-cont m-b-25">
									<i class="icon-personal"></i>
									<input type="text" v-model.trim="regParams.phone" maxlength="11" placeholder="手机号"/>
								</div>
								<div class="input-cont password-su-cont m-b-25">
									<i class="icon-lock"></i>
									<input type="password" v-model.trim="regParams.password" placeholder="密码" />
								</div>
								<div class="input-cont repassword-su-cont m-b-30">
									<i class="icon-lock"></i>
									<input type="password" v-model.trim="regParams.password2" @keyup.enter="handleRegister" placeholder="确认密码"/>
								</div>
							</div>
							<div class="fx-align btns p-t-10">
								<div class="fx-fill">
									<div class="sign-up-btn"><a @click="handleRegister">注<span class="p-l-20"></span>册</a></div>
									<div class="operation fx-align p-t-20">
										<a @click="handleStatus('sign-in')">去登录</a>
									</div>
								</div>
							</div>
						</div>
					</div>
				</section>
			</div>
			<section class="bg-pic"><canvas id="canvas"></canvas></section>
		</div>
		<section :class="{'fn-hide':!isResetPwd}" class="password-retrieval-wapper fx-align">
			<div class="step">
				<h2>重置密码</h2>
				<div class="input-cont m-b-20">
					<input type="tel" maxlength="11" v-model.trim="resetPwdParams.phone" placeholder="手机号" />
				</div>
				<div class="input-cont m-b-20">
					<input type="password" maxlength="30" v-model.trim="resetPwdParams.password" placeholder="新密码" />
				</div>
				<div class="input-cont m-b-20">
					<input type="password" maxlength="30" v-model.trim="resetPwdParams.password2" placeholder="确认新密码" />
				</div>
				<div class="input-cont m-b-20">
					<input maxlength="4" type="tel" v-model.trim="resetPwdParams.code" placeholder="请输入4位手机验证码" />
					<a class="send-cond" @click="handleSendSmsCode">{{codeText}}</a>
				</div>
				<div class="btn-cont m-t-30">
					<a class="btn-next" @click="handleResetPwd">确认重置</a>
				</div>
				<div class="m-t-15">
					<a class="btn-back" @click="handleRetrievePwd">返回</a>
				</div>
			</div>
		</section>
		<footer class="text-center">©<span class="p-l-5 p-r-10">重庆欣业邦网络技术有限公司</span>版权所有</footer>
	</section>
</template>
<script>
	import { mapActions } from 'vuex'
	import canvas from '@/assets/js/canvas.js'
	import gt from '@/utils/gt.js'
	export default {
		name: 'login',
		data() {
			return {
				isWait:true,
				captchaObj:{},
				status: '',
				isResetPwd :false,
				codeText: '发送验证码',
				active: false,//验证码显示状态
				params: {
					phone: null,
					password: null
				},
				regParams: {
					phone: null,
					password: null,
					password2: null
				},
				resetPwdParams:{
					phone:'',
					password:'',
					password2:'',
					code:''
				}
			}
		},
		mounted (){
			
			this.handleRegisterFullpage()
	    },
		/*
		 * 属性计算
		 */
		computed: {},
		/*
		 * 事件处理
		 */
		methods: {
			async handleSendSmsCode() {
				if(this.active) {
                    return;
                }
				if(!this.$re_phone(this.resetPwdParams.phone)) return  this.$warning('请输入正确的手机号 ( ･´ω`･ )')
				try{
					await this.sendSmsCode({phone: this.resetPwdParams.phone})
					//验证码倒计时
					this.$success('验证码已发送到：' + this.resetPwdParams.phone)
					let timeCount = 59;
                    this.codeText = timeCount + 's后重新获取';
                    this.active = true;
                    let timer = setInterval(() => {
                        if(timeCount == 0) {
                            clearInterval(timer); //停止计时器
                            this.codeText = '获取验证码';
                            this.active = false;
                        } else {
                            timeCount--;
                            this.codeText = timeCount + 's后重新获取';
                        }
                    }, 1000); //启动计时器，1秒执行一次
				}catch(e){
					this.$errorMsg(e)
				}
			},
			async handleResetPwd(){
				if(!this.$re_phone(this.resetPwdParams.phone)){
					return  this.$warning('请输入正确的手机号 ( ･´ω`･ )')
				}
				if(!this.resetPwdParams.password) {
					return  this.$warning('请输入新密码 (灬°ω°灬)')
				}
				if(!this.resetPwdParams.password2) {
					return  this.$warning('请输入确认新密码 (灬°ω°灬)')
				}
				if((this.resetPwdParams.password).length < 6) {
					return  this.$warning('为了您的账号安全,建议密码长度大于6位 ( ･´ω`･ )')
				}
				if(this.resetPwdParams.password != this.resetPwdParams.password2) {
					return  this.$warning('两次密码不一致哟 ╮(・o・)╭')
				}
				if((this.resetPwdParams.code).length != 4) {
					return  this.$warning('请输入4位手机验证码(灬°ω°灬)')
				}
				try{
					await this.resetPwd(this.resetPwdParams)
					this.$success('重置成功')
					const data = await this.login({
						phone:this.resetPwdParams.phone,
						password:this.resetPwdParams.password
					})
					if(data.auth =='mp'){
						this.$router.replace({ name: 'index' })
					}
					if(data.auth =='mg'){
						this.$router.replace({ name: 'mgIndex' })
					}
				}catch(e){
					this.$errorMsg(e)
				}
				
			},
			async handleRegisterFullpage(){
				const data = await this.registerFullpage()
	            initGeetest({
	                gt: data.gt,
	                challenge: data.challenge,
	                offline: !data.success, // 表示用户后台检测极验服务器是否宕机
	                new_captcha: data.new_captcha, // 用于宕机时表示是新验证码的宕机
	
	                product: "popup", // 产品形式，包括：float，popup
	                width: "300px"
	            }, (captchaObj)=>{
	            	this.captchaObj = captchaObj
	            	captchaObj.appendTo('#captcha'); // 同时插入三个input表单时，geetest_challenge, geetest_validate, geetest_seccode
	            	this.isWait = false
	            });
			},
			//找回密码
			handleRetrievePwd() {
				this.isResetPwd = this.isResetPwd? false: true
			},
			handleStatus(type) {
				this.status = type
			},
			handleLogin() {
				if(!this.$re_phone(this.params.phone)){
					return  this.$warning('请输入正确的手机号 ( ･´ω`･ )')
				}
				if(!this.params.password) {
					return  this.$warning('请输入密码 (灬°ω°灬)')
					
				}
				const result = this.captchaObj.getValidate();
				if(!result) return  this.$warning('请点击按钮进行验证 ( ･´ω`･ )')
				this.login(this.params).then((data) => {
					this.$setSessionStorage('CURRENT_LOGIN_STATUS', 'LOGIN');
					this.$success('登录成功')
					if(data.auth =='mp'){
						this.$router.replace({ name: 'index' })
					}
					if(data.auth =='mg'){
						this.$router.replace({ name: 'mgIndex' })
					}
				}, (msg) => {
					 this.$warning(msg)
				})
			},
			handleRegister() {
				if(!this.$re_phone(this.regParams.phone)){
					return  this.$warning('请输入正确的手机号 ( ･´ω`･ )')
				}
				if(!this.regParams.password) {
					return  this.$warning('请输入密码 (灬°ω°灬)')
				}
				if(!this.regParams.password2) {
					return  this.$warning('请输入确认密码 (灬°ω°灬)')
				}
				
				if((this.regParams.password).length < 6) {
					return  this.$warning('为了您的账号安全,建议密码长度大于6位 ( ･´ω`･ )')
				}
				if(this.regParams.password != this.regParams.password2) {
					return  this.$warning('两次密码不一致哟 ╮(・o・)╭')
				}
				this.register(this.regParams).then((data) => {
					this.$success('注册成功')
					this.$router.replace({ name: 'index' })
//					window.location.replace('/admin/index')
				}, (msg) => {
					 this.$warning(msg)
				})
			},
			...mapActions(['login','register','registerFullpage','sendSmsCode','resetPwd']), // 映射 this.LOGIN() 为 this.$store.dispatch('login')
		},
	}
</script>

<style scoped lang="scss">
@import "src/assets/css/common.scss";
	$color-px:#2bb673;
	/*找回密码*/
	.password-retrieval-wapper{
		position: absolute;
		left: 0;
		top: 0;
		width: 100%;
		height: 100%;
		z-index: 2;
		.step{
			text-align: center;
			width: 380px;
			padding: 40px;
			background: #fff;
			border-radius: 10px;
		}
		h2{
			font-size: 28px;
			padding-bottom: 20px;
		}
		.input-cont{
			width: 100%;
			position: relative;
			input{
				padding: 15px 20px;
				border: 1px solid #ddd;
				width: 100%;
			}
			.send-cond{
				position: absolute;
				right: 20px;
				top: 15px;
			}
		}
		.btn-cont{
			width: 100%;
			a{
				display: block;
				width: 100%;
				height: 44px;
				line-height: 44px;
				text-align: center;
				font-size: 16px;
				background: $color-px;
				border-radius: 44px;
				color: #fff;
				transition: all 0.25s ease-in-out;
				transform: scale(1) translateY(0);
				&:hover{
					opacity: 1;
					transform: translateY(-2px);
					box-shadow: 0 3px 3px rgba(0,0,0,0.2);
					background: lighten($color-px,5%);
				}
			}
		}
		.btn-back{
			position: relative;
			&:after{
				content: "";
				width: 100%;
				height: 1px;
				background: #566065;
				position: absolute;
				left: 0;
				bottom: -3px;
				transition: all 0.2s ease;
				transform: scaleX(0);
				opacity: 0.8;
			}
			&:hover{
				&:after{
					transform: scaleX(1);
				}
			}
		}
	}
	.login-wapper {
		position: absolute;
		left: 0;
		top: 0;
		width: 100%;
		height: 100%;
		overflow: hidden;
		.wapper {
			position: relative;
			width: 380px;
			height: 490px;
			border-radius: 10px;
			z-index: 2;
			overflow: hidden;
			/*background: linear-gradient(#121626 10%, #fff 11%);*/
		}
	}
	/*登录*/
	.logo-wapper{
		z-index: 9;
		position: relative;
		padding: 40px 80px;
		.logo-words{
			width: 114px;
			img{
				width: 100%;
			}
			.ad-words{
				color: #767676;
				font-size: 16px;
			}
		}
		.logo-cont{
			width: 80px;
			position: relative;
			z-index: 3;
			img {
				width: 100%;
			}
		}
	}
	
	/*user-info*/
	.user-info-cont{
		position: relative;
		background: #fff;
		height: 330px;
		border-bottom-left-radius: 10px;
		border-bottom-right-radius: 10px;
	}
	.login-cont,.sign-up-cont {
		position: absolute;
		top: 0;
		left: 0;
		width: 100%;
		padding: 40px;
		z-index: 1;
		.input-cont{
			position: relative;
			input {
				width: 100%;
				padding: 5px 25px;
				background: rgba(0, 0, 0, 0);
				border: 0;
				font-size: 16px;
				border-bottom: 1px solid #ddd;
				position: relative;
				transition: all 0.3s ease-out;
				&:focus{
					box-shadow: 0 3px 1px 0 rgba(43, 182, 115, 0.2) !important;
				}
			}
			.icon{
				position: absolute;
				top: 5px;
				left: 0;
				color: #acacac;
			}
		}
		.login-btn,.sign-up-btn{
			display: inline-block;
			width: 100%;
			height: 44px;
			line-height: 44px;
			text-align: center;
			font-size: 16px;
			a{
				display: inline-block;
				width: 100%;
				background: $color-px;
				border-radius: 44px;
				color: #fff;
				transition: all 0.25s ease-in-out;
				transform: scale(1) translateY(0);
				&:hover{
					opacity: 1;
					transform: translateY(-2px);
					box-shadow: 0 3px 3px rgba(0,0,0,0.2);
					background: lighten($color-px,5%);
				}
			}
		}
	}
	/*btn*/
	.login-cont .btns a,
	.sign-up-cont .sign-up-btn a{
		display: block;
	}
	
	.login-cont .btns .operation a,
	.sign-up-cont .btns .operation a {
		color: #ABABAB;
		transition: all 0.2s ease;
	}
	
	.login-cont .btns .operation a:hover,
	.sign-up-cont .btns .operation a:hover {
		color:$color-px;
	}
	
	.register .login-cont .input-cont,
	.register .login-cont .btns .login-btn,
	.sign-in .login-cont .input-cont,
	.sign-in .login-cont .btns .login-btn,
	.sign-in .login-cont .btns .operation {
		opacity: 1;
	}
	/*背景*/
	.bg-pic {
		position: absolute;
		top: 0;
		left: 0;
		right: 0;
		bottom: 0;
		z-index: 1;
		width: 100%;
		height: 100%;
		background: linear-gradient(to bottom,#000,#0e142e);
	}
	
	/*--------------------------无耻的分割线---------------------------*/
	/*动画*/
	/*登录界面显示*/
	.logo-wapper{
		background: rgba(0,0,0,0);
		box-shadow: 0 0 0 0 rgba(0,0,0,0);
		animation: logo-wapper-anima 0.5s ease-out 1.5s forwards;
		.logo-cont{
			transform: translate(100px,0);
			transform-origin: center 50px;
			animation: logo-anima 1.5s ease-in-out forwards;
		}
		.logo-words{
			transform-origin: left center;
			animation: words-anima 0.55s ease-out 0.85s forwards;
			opacity: 0;
			transform: translate(40px,0) scale(1,1);
			.ad-words{
				opacity: 0;
				transform: translate(0,-15px);
				animation: ad-anima 0.4s ease-out 1.6s forwards;
			}
		}
	}
	@keyframes logo-anima{
		0%{
			transform: translate(100px,0) scale(0) rotate(0) skewX(0);
		}
		15%{
			transform: translate(100px,0) scale(1.5) rotate(0) skewX(0);
		}
		18%{
			transform: translate(100px,0) scale(0.9) rotate(0) skewX(0);
		}
		22%{
			transform: translate(100px,0) scale(1.1) rotate(0) skewX(0);
		}
		25%,45%{
			transform: translate(100px,0) scale(1) rotate(0) skewX(0);
		}
		48%{
			transform: translate(130px,0) scale(1) rotate(5deg) skewX(-10deg);
		}
		60%{
			transform: translate(-20px,0) scale(1) rotate(-13deg) skewX(15deg);
		}
		73%{
			transform: translate(5px,0) scale(1) rotate(5deg) skewX(-5deg);
		}
		83%{
			transform: translate(-3px,0) scale(1) rotate(-3deg) skewX(0);
		}
		100%{
			transform: translate(0,0) scale(1) rotate(0) skewX(0);
		}
	}
	@keyframes words-anima{
		0%{
			opacity: 0;
			transform: translate(50px,0) scale(1.5,0.5);
		}
		38%{
			opacity: 1;
			transform: translate(-10px,0) scale(0.3,1.5);
		}
		60%{
			opacity: 1;
			transform: translate(8px,0) scale(1.2,0.85);
		}
		85%{
			opacity: 1;
			transform: translate(-3px,0) scale(0.9,1.05);
		}
		100%{
			opacity: 1;
			transform: translate(0,0) scale(1,1);
		}
	}
	@keyframes ad-anima{
		0%{
			opacity: 0;
			transform: translate(0,-15px);
		}
		100%{
			opacity: 1;
			transform: translate(0,0);
		}
	}
	@keyframes logo-wapper-anima{
		0%{
			background: rgba(0,0,0,0);
			box-shadow: 0 0 0 0 rgba(0,0,0,0);
		}
		100%{
			background: rgba(55,71,79,1);
			box-shadow: 0 3px 10px 0 rgba(0,0,0,0.3);
		}
	}
	.user-info-cont{
		opacity: 0;
		visibility: hidden;
		transform: translate(0,-100%);
		animation: info-cont-anima 0.4s ease-out 2s forwards;
	}
	@keyframes info-cont-anima{
		0%{
			opacity: 0;
			transform: translate(0,-100%);
		}
		1%{
			opacity: 1;
			visibility: visible;
			transform: translate(0,-100%);
		}
		100%{
			opacity: 1;
			visibility: visible;
			transform: translate(0,0);
		}
	}
	/*登录注册界面切换*/
	/*注册*/
	.register .login-cont .input-cont,
	.register .login-cont .btns .login-btn,
	.register .login-cont .btns .operation {
		animation: login-out-anim 0.4s ease-in forwards;
	}
	
	.register .login-cont .btns .login-btn {
		animation-delay: 0.1s;
	}
	
	.register .login-cont .input-cont.code-cont {
		animation-delay: 0.18s;
	}
	
	.register .login-cont .input-cont.password-cont {
		animation-delay: 0.25s;
	}
	
	.register .login-cont .input-cont.name-cont {
		animation-delay: 0.33s;
	}
	
	@keyframes login-out-anim {
		0% {
			transform: translate(-0, -0);
		}
		100% {
			transform: translate(-0, 300px);
		}
	}
	
	.register .sign-up-cont .input-cont,
	.register .sign-up-cont .btns .sign-up-btn,
	.register .sign-up-cont .btns .operation {
		transform: translate(-0, 300px);
		animation: su-in-anim 0.4s ease-out forwards;
	}
	
	.register .sign-up-cont .input-cont.name-su-cont {
		animation-delay: 1s;
	}
	
	.register .sign-up-cont .input-cont.password-su-cont {
		animation-delay: 1.1s;
	}
	
	.register .sign-up-cont .input-cont.repassword-su-cont {
		animation-delay: 1.2s;
	}
	
	.register .sign-up-cont .btns .sign-up-btn {
		animation-delay: 1.3s;
	}
	
	.register .sign-up-cont .btns .operation {
		animation-delay: 1.4s;
	}
	
	@keyframes su-in-anim {
		0% {
			transform: translate(-0, 300px);
		}
		100% {
			transform: translate(-0, 0);
		}
	}
	/*登陆*/
	
	.sign-in .login-cont .input-cont,
	.sign-in .login-cont .btns .login-btn,
	.sign-in .login-cont .btns .operation {
		transform: translate(-0, 300px);
		animation: login-in-anim 0.4s ease-out 1.4s forwards;
	}
	
	.sign-in .login-cont .btns .login-btn {
		animation-delay: 1.4s;
	}
	
	.sign-in .login-cont .input-cont.code-cont {
		animation-delay: 1.3s;
	}
	
	.sign-in .login-cont .input-cont.password-cont {
		animation-delay: 1.2s;
	}
	
	.sign-in .login-cont .input-cont.name-cont {
		animation-delay: 1.1s;
	}
	
	@keyframes login-in-anim {
		0% {
			transform: translate(-0, 300px);
		}
		100% {
			transform: translate(-0, 0);
		}
	}
	
	.sign-in .sign-up-cont .input-cont,
	.sign-in .sign-up-cont .btns .sign-up-btn,
	.sign-in .sign-up-cont .btns .operation {
		animation: su-out-anim 0.4s ease-in forwards;
	}
	
	.sign-in .sign-up-cont .input-cont.name-su-cont {
		animation-delay: 0.5s;
	}
	
	.sign-in .sign-up-cont .input-cont.password-su-cont {
		animation-delay: 0.4s;
	}
	
	.sign-in .sign-up-cont .input-cont.repassword-su-cont {
		animation-delay: 0.3s;
	}
	
	.sign-in .sign-up-cont .btns .sign-up-btn {
		animation-delay: 0.2s;
	}
	
	.sign-in .sign-up-cont .btns .operation {
		animation-delay: 0.1s;
	}
	
	@keyframes su-out-anim {
		0% {
			transform: translate(-0, -0);
		}
		100% {
			transform: translate(-0, 300px);
		}
	}
	
	.wapper .sign-up-cont {
		display: none;
	}
	
	.wapper.sign-in .sign-up-cont,
	.wapper.register .sign-up-cont {
		display: block;
	}
	
	.register .login-cont {
		transition: 0.1s all;
		visibility: hidden;
		transition-delay: 0.7s;
	}
	
	.sign-in .sign-up-cont {
		transition: 0.1s all;
		visibility: hidden;
		transition-delay: 0.9s;
	}
	footer{
		width: 100%;
		position: fixed;
		bottom: 20px;
		left: 0;
		color: #888;
		z-index: 99;
	}
	@media only screen and (min-width:0px) and (max-width:640px) {
		.login-wapper .wapper{
			width: 310px;
		}
		.logo-wapper{
			padding: 24px;
		}
	}
	
	
</style>


// WEBPACK FOOTER //
// Login.vue?0116f14d